const ALWAYS_RETRYABLE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

const RETRYABLE_POST_PATHS = [
  '/api/v1/indicators/ids',
  '/api/v1/phenomena/ids',
  '/api/v1/products/ids',
  '/api/v1/vendors/ids',
  '/v1/analytics/dashboard',
  '/v1/analytics/traps-severity',
  '/v1/crops/ids',
  '/v1/panel/property/{id}/regions/last-event',
  '/v1/timeline/events',
  '/v1/timeline/static-points',
  '/v1/timeline/window',
  '/v1/tracking/query',
  '/v2/auth/verify',
  '/v2/catalog/seeds/query',
  '/v2/fields/ids',
  '/v2/orgs/{id}/workers-by-properties',
  '/v2/orgs/{id}/workers/ids',
  '/v2/season-fields/list',
  '/v3/operations/ag/filtered',
  '/v1/observations/properties/{propertyId}/fields/days-without-observations',
  '/v1/observations/properties/{propertyId}/fields/scouting-windows/count',
  '/web-server/v1/timeline/days-without-spraying',
  '/oauth/token'
] as const;

const PATH_PARAM_PLACEHOLDER = /\{[^/{}]+\}/g;
const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]]/g;

function compilePattern(pattern: string): RegExp {
  const segments = pattern.split(PATH_PARAM_PLACEHOLDER).map(segment => segment.replace(REGEX_SPECIAL_CHARS, match => `\\${match}`));
  return new RegExp(`^${segments.join('[^/]+')}$`);
}

const RETRYABLE_POST_PATH_REGEXES = RETRYABLE_POST_PATHS.map(compilePattern);

function isRetryablePostPath(url: string): boolean {
  let pathname: string;
  try {
    pathname = new URL(url, 'https://protector.invalid').pathname;
  } catch {
    return false;
  }
  return RETRYABLE_POST_PATH_REGEXES.some(regex => regex.test(pathname));
}

export function isRetryableRequest(method: string | undefined, url: string | undefined): boolean {
  const normalizedMethod = method?.toUpperCase();
  if (!normalizedMethod) return false;
  if (ALWAYS_RETRYABLE_METHODS.has(normalizedMethod)) return true;
  if (normalizedMethod !== 'POST') return false;
  if (!url) return false;
  return isRetryablePostPath(url);
}
